module.exports = __webpack_public_path__ + "img/1088978354.e00b4d5e.jpg";